<div *ngIf="messageService.messages.length" class="alert alert-info alert-dismissible fade show" role="alert">
        <div *ngFor='let message of messageService.messages'> {{message}} </div>
        <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true" (click)="messageService.clear()"></span></button>
</div>